import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { withStyles } from '@material-ui/core/styles';

import Badge from 'fuse-ui/components/Badge';
import Button from 'fuse-ui/components/Button';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from 'fuse-ui/components/Tooltip';
import Typography from 'fuse-ui/components/Typography';

const styles = theme => ( {
    actionBtn: {
        'float': 'right',
        height: 36,
        marginRight: theme.spacing.unit,
        padding: 0,
        width: 36,
    },
    badge: {
        marginLeft: theme.spacing.unit * 2
    },
    canvasHeader: {
        backgroundColor: theme.palette.background.paper,
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: theme.spacing.unit,
    },
    fixedCanvasHeader: {
        margin: `-${theme.spacing.unit * 2}px 0 0 -${theme.spacing.unit * 2}px`,
        padding: `${theme.spacing.unit * 2}px 0 ${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
        position: 'fixed',
        width: `calc(100% - ${theme.spacing.unit * 8}px)`,
        zIndex: theme.zIndex.drawer
    },
    icon: {
        fontSize: 28
    },
    title: {
        alignItems: 'center',
        display: 'flex',
    }
} );

export const CanvasHeader = ( {
    canvasDetails,
    classes,
    handleCloseSettingsPane,
    handleOpenSettingsPane,
    handleSaveSettings,
    isEditMode,
    isFormDirty
} ) => {
    return (
        <div className={cx( classes.canvasHeader, {
            [classes.fixedCanvasHeader]: isEditMode
        } )}>
            <div className={classes.textSection}>
                <div className={classes.title}>
                    <Typography variant="h5">{canvasDetails.name}</Typography>
                    {
                        isEditMode &&
                        <Badge label="Editing Mode" variant="outlined" className={classes.badge} />
                    }
                </div>
                <Typography variant="subtitle1" color="textSecondary">
                    {`Messages sent in the last ${canvasDetails.params.previousDays} days`}
                </Typography>
            </div>
            <div>
                {
                    isEditMode ? (
                        <>
                            <Button
                                className={classes.actionBtn}
                                disabled={!isFormDirty}
                                onClick={handleSaveSettings}
                            >
                                Save
                            </Button>
                            <Button
                                className={classes.actionBtn}
                                onClick={handleCloseSettingsPane}
                                variant="text"
                            >
                                Cancel
                            </Button>
                        </>
                    ) : (
                        <Tooltip title="Edit">
                            <IconButton
                                className={classes.actionBtn}
                                onClick={handleOpenSettingsPane}
                                data-automation-id="canvas-edit-mode-button"
                            >
                                <EditIcon className={classes.icon} />
                            </IconButton>
                        </Tooltip>
                    )
                }
            </div>
        </div>
    );
};

CanvasHeader.propTypes = {
    canvasDetails: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
    handleCloseSettingsPane: PropTypes.func.isRequired,
    handleOpenSettingsPane: PropTypes.func.isRequired,
    handleSaveSettings: PropTypes.func.isRequired,
    isEditMode: PropTypes.bool.isRequired,
    isFormDirty: PropTypes.bool.isRequired,
};

export default withStyles( styles )( CanvasHeader );
